import { FC, ReactElement } from "react";

import useAuth from "@hooks/useAuth";
import { useCorban } from "@hooks/useCorban";
import usePermissions from "@hooks/usePermissions";

import PageLoading from "../PageLoading";

type AppConfigProps = {
  children: ReactElement;
};

const AppConfig: FC<AppConfigProps> = ({ children }) => {
  const { loading: userLoading } = useAuth();
  const { needCorbanSelection } = useCorban();
  const { loading: permissionsLoading } = usePermissions();

  if (userLoading || (permissionsLoading && !needCorbanSelection)) {
    return <PageLoading />;
  }

  return children;
};

export default AppConfig;
